import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
// import { this.props.history } from 'react-router';
import { bindActionCreators } from 'redux';
import * as documentUploadActions from '../../../actions/documentUploadActions';
import * as specialistActions from '../../../actions/specialistActions';
import Pagination from "react-js-pagination";
import Moment from 'react-moment';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import * as ImageUrl from "../../../constants/constant";
import DatePicker from 'react-datepicker';
import Switch from "react-switch";
import moment from 'moment';

class SpecialistDocuments extends React.Component {
	constructor(props, context) {
		super(props, context);
		this.state = {
			isLoader: true,
			specialistDocument: [],
			token: '',
			flag: 1,
			activePage: 1,
			count: 10,
			sortColumnName: '',
			sortOrder: -1,
			checked: false,
			documents: {},
			documentTypes: [],
			documentTypesOri:[],
			disabled: true,
			totlen: ''
		}
		this.handlePageChange = this.handlePageChange.bind(this);
		this._sortClass = this._sortClass.bind(this);
		this.sortChanged = this.sortChanged.bind(this);
		this.handleChangeChk = this.handleChangeChk.bind(this);
		// this.handleChange = this.handleChange.bind(this);
		this.vetUser = this.vetUser.bind(this);
		this.notifyUser = this.notifyUser.bind(this);
	}

	componentWillMount() {
		let objectDocument = {
			page: this.state.activePage,
			count: this.state.count,
			userId: this.props.match.params.specialistId
		}
		this.props.actions.getAllDocumentTypes(objectDocument);
		this.props.actions.getSpecialistDocument(objectDocument);
	}

	vetUser() {
		confirmAlert({
			title: 'Confirm',
			message: 'Is Specialist vetted?',
			buttons: [
				{
					label: 'Yes',
					onClick: () => {
						var verifyObj = {
							isRegistrationVerified: true,
							isAddressVerified: true,
							isAcademicsVerified: true,
							isIdentityVerified: true,
							isAllVerified: true,
							userId: this.props.match.params.specialistId,
							verify: 'all'
						}
						this.props.specialistactions.updateSpecialistVerification(verifyObj)
						this.props.history.push('/user/specialistuser')
					}
				},
				{
					label: 'No',
					onClick: () => { }
				}
			]
		})
	}


	notifyUser() {
		confirmAlert({
			title: 'Confirm',
			message: 'Are you sure you want to Notify user?',
			buttons: [
				{
					label: 'Yes',
					onClick: () => {
						let cert = [];
						console.log(JSON.stringify(this.state.documentTypes))
						this.state.documentTypes.forEach(function (item, index) {
							cert.push(item.name)
						})

						let certObj = { certificates: cert, userId: this.props.match.params.specialistId }
						this.props.specialistactions.missedDocuments(certObj)
					}
				},
				{
					label: 'No',
					onClick: () => { }
				}
			]
		})
	}

	handleChange = (itemname, totallen, id, checked, docTypeId) => {
		console.log("iteme",checked, docTypeId )
		if (checked == true) {
			totallen = totallen - 1;
			this.setState({
				totlen: totallen
			})
			console.log(this.state.totlen)
			var obj = {
				docId: id,
				status: true,
				page: this.state.activePage,
				count: this.state.count,
				userId: this.props.match.params.specialistId,
				docTypeId,
			}
			this.props.actions.updateDocumentStatus(obj);
		} else {
			totallen = totallen + 1;
			this.setState({
				totlen: totallen
			})
			console.log(this.state.totlen)
			var obj = {
				docId: id,
				status: false,
				page: this.state.activePage,
				count: this.state.count,
				userId: this.props.match.params.specialistId,
				docTypeId,
			}
			this.props.actions.updateDocumentStatus(obj);
		}
		this.setState({ checked });
		this.state.documents[itemname] = checked;
		let updateState = Object.assign({}, this.state.documents);
		this.state.documents[itemname] = checked;
		this.setState({ updateState });

		// if (itemname == 'Degree Certificate') {
		// 	var obj = {
		// 		value: checked,
		// 		item: 'isAcademicsVerified',
		// 		userId: this.props.match.params.specialistId
		// 	}
		// 	this.props.specialistactions.updateSpecialistVerification(obj)
		// }

		if (totallen == 0) {
			this.setState({
				disabled: false
			})
		} else {
			this.setState({
				disabled: true
			})
		}

	}

	handlePageChange(pageNumber) {
		this.setState({ activePage: pageNumber });
		let objectDocument = {
			page: pageNumber,
			count: this.state.count,
			userId: this.props.match.params.specialistId
		}
		this.props.actions.getSpecialistDocument(objectDocument);
	}

	handleChangeChk() {
		this.setState({ checked });
	}

	// function for set sort icon on table header
	_sortClass(filterName) {
		return "fa fa-fw " + ((filterName == this.state.sortColumnName) ? ("fa-sort-" + this.state.sortOrder) : "fa-sort");
	}

	//function for sorting
	sortChanged(sortColumnName, order, e) {
		e.preventDefault();
		this.state.sortColumnName = sortColumnName;
		this.state.page = 1;
		this.state.sortOrder = order == 1 ? -1 : 1;

		let userToken = localStorage.getItem('token');
		let specialistId = this.props.match.params.specialistId;
		const sorting = {}
		sorting[sortColumnName] = order.toString().toLowerCase() == 1 ? -1 : 1
		this.state.sorting = sorting;
		let objectDocument = {
			page: this.state.page,
			count: this.state.count,
			userId: this.props.match.params.specialistId,
			sorting: sorting
		}
		this.props.actions.getSpecialistDocument(objectDocument);
	}
	blockingDateChanged = async (selectedDate, item) => {
		let todayDate = selectedDate ? selectedDate : this.state.blockingDate
		var convertDate = new Date(moment(todayDate).startOf('day'));
		var convertDateEnd = new Date(moment(todayDate).endOf('day'));
		this.setState({
			blockingDate: convertDate
		});
		let data = {
			userId: this.props.match.params.specialistId,
			docTypeId: item._id,
			expiryDate: convertDate,
		}
		await this.props.actions.setDocumentExpiryDate(data, this.props);
		// let objectDocument = {
		// 	page: this.state.activePage,
		// 	count: this.state.count,
		// 	userId: this.props.match.params.specialistId
		// }
		// this.props.actions.getSpecialistDocument(objectDocument, this.props);
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.success) {
			this.setState({
				specialistDocument: nextProps.specialistDocument,
				documentTypes: nextProps.documentTypes && nextProps.documentTypes.docs ,
				documentTypesOri: nextProps.documentTypesLength,
				totalCount: nextProps.totalCount,
				isLoader: false,
				specialistUplDocs: nextProps.specialistDocument.length > 0 ? nextProps.specialistDocument[0].userData : [],
				docsLen: nextProps.documentTypes ? nextProps.documentTypes.docs && nextProps.documentTypes.docs.length : 0,
				//  totlen: nextProps.documentTypes.length
				// disabled: nextProps.documentTypesLength == 0 ? false : true
			})
		} else {
			this.setState({
				isLoader: false
			})
		}
	}
	componentWillUnmount() { 
		this.setState({totlen:'',documentTypes:[]}) 
	}
	render() {
		var specialistDocument = this.state.specialistDocument
		var len = specialistDocument.length;
		var totlen = this.state.totlen !== '' ? this.state.totlen : (this.state.documentTypesOri - this.state.totalCount);
		var rows = [];
		this.state.specialistDocument.forEach(function (item, index) {
			// var documentPath =
			// 	ImageUrl.PRODUCTION_IMAGE_URL +
			// 	"uploads/" +
			// 	this.props.match.params.specialistId +
			// 	"/" +
			// 	item.documentUrl;
			var id = "normal-switch" + index;
			var removeIndex = this.state.documentTypes && this.state.documentTypes.map(function (item) { return item.name; })
				.indexOf(item.documentTypeName);
			if (removeIndex != -1) {
				this.state.documentTypes ? this.state.documentTypes.splice(removeIndex, 1) : '';
				// totlen = totlen - 1;
			}
			rows.push(<tr key={index}>
				<td>
					{item.documentName}
				</td>
				<td>{item.documentTypeName} </td>
				<td>
					{item.documentOriginalName && item.documentOriginalName.map((a, i) => {
						var documentPath =
						ImageUrl.PRODUCTION_IMAGE_URL +
						"uploads/" +
						this.props.match.params.specialistId +
						"/" +
						item.documentUrl[i];
						return <a href={documentPath} target="_blank"><p>{a}<br></br></p></a>
					})}
				</td>
				{item._id == 6 || item._id == 7 ? <td>
					 {/* <Moment format="DD-MMM-YYYY">{item.createdAt}</Moment>      */}
					 <div className="date-picker form__form-group-input-wrap form__form-group-input-wrap--error-above">
									<div className="input-group date inputBg dateInputfild" style={{ color: '#4d4d4d !important' }}>
										<div className="input-group-addon"><i className="fa ">
											<img src={require('../../../images/img/date_input_icon.svg')} /></i></div>
										<DatePicker
											name="blockingdate"
											dateFormat="dd-MM-yyyy"
											selected={new Date(item.expiryDate ? item.expiryDate: item.createdAt)}
											onChange={(date) => this.blockingDateChanged(date, item)}
											placeholderText="Date"
											// maxDate={moment().add(2, 'year')}
											// minDate={new Date()}
											showMonthDropdown
											showYearDropdown={true}
											shouldCloseOnSelect={true}
										/>
									</div>
								</div>
					 </td> : '-'}
				<td> <Moment format="DD-MMM-YYYY">{item.createdAt}</Moment>     </td>
				{(item._id == 6 || item._id == 7) ? (item.expiryDate != null ? <td>
					<label htmlFor={id}>
						<Switch
							onChange={() => this.handleChange(item.documentTypeName, totlen, item._id, item.isVerified ? false : true, item._id)}
							checked={item.isVerified ? true : false}
							className="react-switch"
							id={id}
							onColor="#00B6E4"
						/>
					</label>
				</td> : null ): <td>
					<label htmlFor={id}>
						<Switch
							onChange={() => this.handleChange(item.documentTypeName, totlen, item._id, item.isVerified ? false : true, item._id)}
							checked={item.isVerified ? true : false}
							className="react-switch"
							id={id}
							onColor="#00B6E4"
						/>
					</label>
				</td>}

			</tr>)
		}.bind(this));
		// this.state.documentTypes && this.state.documentTypes.forEach(function (item, index) {
		// 	if (item.id < 8) {
		// 	var id = "normal-switch" + (len + index);
		// 	rows.push(<tr key={len + index}>
		// 		<td>
		// 		</td>
		// 		<td>{item.name}</td>
		// 		<td></td>
		// 		<td> </td>
		// 		<td> </td>
		// 		<td>
		// 			<label htmlFor={id}>
		// 				<Switch
		// 					onChange={() => this.handleChange(item.name, totlen, item.id, true, item.id)}
		// 					checked={this.state.documents[item.name] ? this.state.documents[item.name] : false}
		// 					className="react-switch"
		// 					id={id}
		// 					onColor="#00B6E4"
		// 				/>
		// 			</label>
		// 		</td>

		// 	</tr>)
		// 	}
		// }.bind(this));
		return (
			<div className="content-wrapper">

				<section className="content container-fluid">
					<ToastContainer />
					<div className="row">
						<div className="col-md-12">
							<div className="boxMrgB proCalendar">
								<div className="nav-tabs-custom">
									<ul className="nav nav-tabs">
										<li ><Link to="#tab_1" data-toggle="tab" className="active show">Uploaded Documents </Link></li>
										<li className=" col-md">
											<div className="content-header"><ol className="breadcrumb">
												<li><Link to="/user/specialistuser">Specialists</Link></li>
												<li className="active">Verification</li>
											</ol></div>
										</li>
									</ul>
									<div className="row">
										<div className="col-md-12">
											<div className="tab-content tabother ">
												<div className="row">
													<div className="box-body table-responsive no-padding aTable">
														<div className="table-responsive">
															<table className="table">
																<tbody>
																	<tr>
																		<th onClick={this.sortChanged.bind(this, 'documentName', this.state.sortOrder)}>
																			Document Name
                                <i className={this._sortClass('appointmentspecialistname')}></i></th>
																		<th onClick={this.sortChanged.bind(this, 'documentTypeName', this.state.sortOrder)}>Document Type<i className={this._sortClass('appointmentspecialistname')}></i></th>
																		<th onClick={this.sortChanged.bind(this, 'documentTypeName', this.state.sortOrder)}>Document<i className={this._sortClass('appointmentspecialistname')}></i></th>
																		<th onClick={this.sortChanged.bind(this, 'expiryDate', this.state.sortOrder)}>Expiry Date<i className={this._sortClass('appointmentspecialistname')}></i></th>
																		<th onClick={this.sortChanged.bind(this, 'createdAt', this.state.sortOrder)}>Uploaded Date<i className={this._sortClass('appointmentspecialistname')}></i></th>
																		<th >Action</th>
																	</tr>
																	{rows && rows.length > 0 ? rows : <tr><td colSpan={4} className="text-center">No Uploaded documents</td></tr>}
																</tbody>
															</table>
														</div>
													</div>
												</div>
												{(this.state.docsLen && this.state.docsLen > 10) ?
													<div className="row">
														<div className="col-sm-5"><div className="showingEntries">Showing {(this.state.activePage * this.state.count) - (this.state.count - 1)} to {(this.state.activePage * this.state.count) > this.state.docsLen ? this.state.docsLen : (this.state.activePage * this.state.count)} of {this.state.docsLen} entries</div></div>
														<div className="col-sm-7 text-right" style={{ "cursor": "pointer" }}>
															<Pagination
																prevPageText='Prev'
																nextPageText='Next'
																hideFirstLastPages
																activePage={this.state.activePage}
																itemsCountPerPage={10}
																totalItemsCount={this.state.docsLen}
																pageRangeDisplayed={10}
																onChange={this.handlePageChange.bind(this)}
															/>

														</div>

													</div> : ''}
												{/* <div className="clearfix"></div> */}
												<div className="text-center">
													{/* <button type="submit" className="btn btn-warning btn-lg pd-btn" data-toggle="modal" data-target="#modal-default" disabled={this.state.disabled} onClick={this.vetUser.bind(this)}>Submit</button> */}
													<button type="submit" className="btn btn-lg pd-btn" data-toggle="modal" data-target="#modal-default" onClick={this.notifyUser.bind(this)} /* disabled={!this.state.disabled} */>Notify</button>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>
				<div className="Copyrightafterlogin">
				<p>Medfix &copy; 2018. All rights reserved</p>

				</div>
			</div>
		);
	}
}

//this tells what state should expose on props
function mapStateToProps(state, ownProps) {
	return {
		specialistDocument: state.uploadDocument.specialistDocument ? state.uploadDocument.specialistDocument.data : [],
		documentTypes: state.uploadDocument.docTypes,
		documentTypesLength:  state.uploadDocument.doclength,
		totalCount: state.uploadDocument.specialistDocument ? state.uploadDocument.specialistDocument.totalCount : 0,
		success: state.uploadDocument.specialistDocument ? state.uploadDocument.specialistDocument.success : false
	};
}
//bindActionCreators is used to bind all actions at once
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(documentUploadActions, dispatch),
		specialistactions: bindActionCreators(specialistActions, dispatch),
	};
}
export default connect(mapStateToProps, mapDispatchToProps)(SpecialistDocuments);